import {secureStorage_getItem} from './secureStorage'

export const returnAccess = () => {
    var access = secureStorage_getItem('access')
    if (access.length === 0){
        return []
    }
    return JSON.parse(access)
}